<scitis-app-global-page-header [pageTitle]="'Organization email templates'">

        <ng-template #filterElement>
        <button (click)="onResetEmailTemplate()"
                [disabled]="(!isAdminRole && !isSuperAdminRole)"
                class="btn btn-outline-primary">
          <span class="fa-solid fa-rotate-left"></span>
          <span translate>Reset</span>
        </button>
        </ng-template>

        <ng-template #filterElement>
        <button (click)="onEmailPreview()"
                [disabled]="(!isAdminRole && !isSuperAdminRole)"
                class="btn btn-outline-primary">
          <span class="fa-solid fa-eye"></span>
          <span translate>Preview</span>
        </button>
        </ng-template>

        <ng-template #filterElement>
        <button (click)="onSaveMailTemplateDetails()"
                [disabled]="(!isAdminRole && !isSuperAdminRole) ||
               !welcomeMailCompleted || !resetPasswordMailCompleted || !changePasswordMailCompleted"
                class="btn btn-primary">
          <span class="fa-solid fa-check"></span>
          <span translate>Save</span>
        </button>
        </ng-template>

</scitis-app-global-page-header>

<ul ngbNav [(activeId)]="selectedTab" class="nav-tabs mb-3">
  <li [ngbNavItem]="templateTypes.WELCOME_EMAIL">
    <a [ngClass]="{'invalid-tenant-mail-setup':!welcomeMailCompleted}"
       (click)="onWelcomeEmailTemplateSelect()" ngbNavLink translate>Welcome Email</a>
  </li>
  <li [ngbNavItem]="templateTypes.PASSWORD_RESET_EMAIL">
    <a [ngClass]="{'invalid-tenant-mail-setup':!resetPasswordMailCompleted}"
       (click)="onPasswordResetEmailTemplateSelect()" ngbNavLink translate>Reset Password Email</a>
  </li>
  <li [ngbNavItem]="templateTypes.PASSWORD_CHANGE_EMAIL">
    <a [ngClass]="{'invalid-tenant-mail-setup':!changePasswordMailCompleted}"
       (click)="onPasswordChangeEmailTemplateSelect()" ngbNavLink translate>Change Password Email</a>
  </li>

</ul>
<div *ngIf="selectedTab === templateTypes.WELCOME_EMAIL">
  <scitis-admin-organization-mail-template
      (validMailEvent)="onEmailValidityChange(templateTypes.WELCOME_EMAIL,$event)"
      [isAdminRole]="isAdminRole"
      [isSuperAdminRole]="isSuperAdminRole"
      [template]="settings.welcomeMail"
      [templateType]="templateTypes.WELCOME_EMAIL">

  </scitis-admin-organization-mail-template>
</div>
<div *ngIf="selectedTab === templateTypes.PASSWORD_RESET_EMAIL">
  <scitis-admin-organization-mail-template
      (validMailEvent)="onEmailValidityChange(templateTypes.PASSWORD_RESET_EMAIL,$event)"
      [isAdminRole]="isAdminRole"
      [isSuperAdminRole]="isSuperAdminRole"
      [template]="settings.resetPasswordMail"
      [templateType]="templateTypes.PASSWORD_RESET_EMAIL">
  </scitis-admin-organization-mail-template>
</div>
<div *ngIf="selectedTab === templateTypes.PASSWORD_CHANGE_EMAIL">
  <scitis-admin-organization-mail-template
      (validMailEvent)="onEmailValidityChange(templateTypes.PASSWORD_CHANGE_EMAIL,$event)"
      [isAdminRole]="isAdminRole"
      [isSuperAdminRole]="isSuperAdminRole"
      [template]="settings.changePasswordMail"
      [templateType]="templateTypes.PASSWORD_CHANGE_EMAIL">
  </scitis-admin-organization-mail-template>
</div>

